export const iconFontAwesomeClothingFashionVest = (
	<i className="fa-solid fa-vest"></i>
);
